import { cn } from '@/lib/utils';

interface EGUserDisplayProps {
  initials?: string | null;
  name?: string | null;
  email?: string | null;
  organization?: string | null;
  inactive?: boolean;
  className?: string;
}

export function EGUserDisplay({
  initials = null,
  name = null,
  email = null,
  organization = null,
  inactive = false,
  className,
}: EGUserDisplayProps) {
  const avatarColour = inactive ? 'bg-primary-muted text-primary-dark' : 'bg-primary-dark';

  return (
    <div className={cn('flex flex-row items-center gap-3', className)}>
      {initials && (
        <div className={cn('flex h-8 w-8 items-center justify-center rounded-full text-xs text-white', avatarColour)}>
          {initials}
        </div>
      )}

      <div className="flex grow flex-col items-start gap-1">
        {name && <div className="text-left font-medium">{name}</div>}
        {organization && <div className="text-muted text-left">{organization}</div>}
        {email && <div className="text-muted text-xs font-normal">{email}</div>}
      </div>
    </div>
  );
}

export default EGUserDisplay;
